import { GridColDef } from '@mui/x-data-grid';
import { Attachment } from '../../../../../../shared/types/shared';
import { fileToBase64 } from '../../../../../../shared/utils/files';
import { PqrAttachmentProps } from './props';
import { PqrAttachmentActions, PqrAttachmentActionsLast } from './actions';
import { TableTooltip } from '../../../../../components/general/table';
import { DateTooltip } from '../../../../../components/general/dateTooltip';
import { ToastSwal } from '../../../../../components/general/toastSwals/toastSwal';

export const usePqrAttachment = ({
    data,
    onChangeData,
}: PqrAttachmentProps) => {
    const handleOnChange = async (files: File[]) => {
        const dataAttachment: Attachment[] = [];
        for await (const file of files) {
            const fileName = file.name.toLowerCase();

            const exists = data?.some((item: Attachment) =>
                item.name.toLowerCase().includes(fileName)
            );

            if (!exists) {
                const res = await fileToBase64(file);
                if (res) dataAttachment.push(res);
            } else {
                ToastSwal.fire({
                    text: `Lo sentimos, no se pudo cargar el archivo ${fileName}, ya existe previamente`,
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            }
        }
        if (onChangeData) onChangeData(dataAttachment);
    };

    const columns: GridColDef<Attachment>[] = [
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <PqrAttachmentActions attachment={row.row} />,
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => <TableTooltip value={row.row.name || ''} />,
        },
        {
            field: 'createdBy',
            headerName: 'Creado por',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.createdBy
                            ? `(${row.row.createdBy.username}) ${row.row.createdBy.name} ${row.row.createdBy.surname}`
                            : ''
                    }
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <DateTooltip date={row.row.created_at} showFornow />
            ),
        },
        {
            field: 'link',
            headerName: 'Web link adjunto',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <PqrAttachmentActionsLast attachment={row.row} />
            ),
        },
    ];

    return {
        handleOnChange,
        data,
        columns,
    };
};
